import { render, staticRenderFns } from "./PanelDynamicEventsV2.vue?vue&type=template&id=133504da&scoped=true"
import script from "./PanelDynamicEventsV2.vue?vue&type=script&lang=js"
export * from "./PanelDynamicEventsV2.vue?vue&type=script&lang=js"
import style0 from "./PanelDynamicEventsV2.vue?vue&type=style&index=0&id=133504da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133504da",
  null
  
)

export default component.exports